import React from "react";
import { Link } from "react-router-dom";
import brand from "../brand";
import "./style.css";

const ErrorPage = () => {
  return (
    <main className="error-page">
      <span className="eyebrow">404</span>
      <h1>Page not found</h1>
      <p>The {brand.shortName} page you are looking for does not exist.</p>
      <Link to="/" className="premium-button">
        Go Home
      </Link>
    </main>
  );
};

export default ErrorPage;
